/**
 * The display name of a subtitle, used for player track labels, the downloads
 * list and the subtitle menu.
 *
 * It is the object's own `title`: the middleware writes a good one at creation
 * and an editor can change it afterwards, so nothing is derived on read.
 *
 * @param {object} item - subtitle object or catalog brain
 * @returns {string}
 */
export function buildSubtitleLabel(item) {
  return item?.title || '';
}
